const NODE_EPHEMERAL_KEYS = new Set([
  'selected',
  'dragging',
  'resizing',
  'measured',
  'positionAbsolute',
  'width',
  'height',
  'internals',
]);

const EDGE_EPHEMERAL_KEYS = new Set([
  'selected',
  'dragging',
  'animated',
]);

function stripDeep(value) {
  if (value == null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(stripDeep);
  const out = {};
  for (const [key, entry] of Object.entries(value)) {
    if (typeof entry === 'function') continue;
    out[key] = stripDeep(entry);
  }
  return out;
}

function sanitizeNode(node) {
  if (!node || typeof node !== 'object') return node;
  const out = {};
  for (const [key, entry] of Object.entries(node)) {
    if (typeof entry === 'function') continue;
    if (NODE_EPHEMERAL_KEYS.has(key)) continue;
    if (key === 'data') {
      out.data = stripDeep(entry);
      continue;
    }
    out[key] = stripDeep(entry);
  }
  return out;
}

function sanitizeEdge(edge) {
  if (!edge || typeof edge !== 'object') return edge;
  const out = {};
  for (const [key, entry] of Object.entries(edge)) {
    if (typeof entry === 'function') continue;
    if (EDGE_EPHEMERAL_KEYS.has(key)) continue;
    if (key === 'data') {
      out.data = stripDeep(entry);
      continue;
    }
    out[key] = stripDeep(entry);
  }
  return out;
}

export function cloneCanvasSnapshot(nodes, edges, identifiedRisks = []) {
  const safeNodes = (Array.isArray(nodes) ? nodes : []).map(sanitizeNode);
  const safeEdges = (Array.isArray(edges) ? edges : []).map(sanitizeEdge);
  const safeRisks = stripDeep(Array.isArray(identifiedRisks) ? identifiedRisks : []);
  try {
    if (typeof structuredClone === 'function') {
      return {
        nodes: structuredClone(safeNodes),
        edges: structuredClone(safeEdges),
        identifiedRisks: structuredClone(safeRisks),
      };
    }
  } catch {
    // fall through to JSON
  }
  return {
    nodes: JSON.parse(JSON.stringify(safeNodes)),
    edges: JSON.parse(JSON.stringify(safeEdges)),
    identifiedRisks: JSON.parse(JSON.stringify(safeRisks)),
  };
}
